import Template from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

const initialCodeState = {
  id: null,
  code: '',
  release: false
}

const initialJsonState = {
  id: null,
  json: ''
}

const initialIconState = {
  id: null,
  icon: ''
}

const initialTextState = {
  id: null,
  text: ''
}

export default {
  namespaced: true,
  state: {
    templates: [],
    filteredCollection: [],
    current: new Template(),
    currentCode: initialCodeState,
    currentJson: initialJsonState,
    currentIcon: initialIconState,
    currentText: initialTextState
  },
  getters: {
    getCollection: state => state.templates,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.templates.find(template => template.id === id),
    getCurrent: state => state.current,
    getCurrentCode: state => state.currentCode,
    getCurrentJson: state => state.currentJson,
    getCurrentIcon: state => state.currentIcon,
    getCurrentText: state => state.currentText
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/templates/theme/' + id,
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((template) => {
            commit('addTemplateToCollection', { templateData: template })
            return getters.getById(template.id)
          })

          commit('addThemeToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getTemplates({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/templates',
        ...payload
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          return { data, meta: res.body.meta }
        }
        return res
      })
    },
    getCode ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/templates/' + id + '/code'
      }).then((res) => {
        commit('updateCurrentCode', res && res.body)
      })
    },
    getJson ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/templates/' + id + '/json'
      }).then((res) => {
        commit('updateCurrentJson', res && res.body)
      })
    },
    getIcon ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/templates/' + id + '/icon'
      }).then((res) => {
        commit('updateCurrentIcon', res && res.body)
      })
    },
    getText ({ commit }, id) {
      return this.dispatch('get', {
        path: 'v1/templates/' + id + '/text'
      }).then((res) => {
        commit('updateCurrentText', res && res.body)
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/templates',
        data: model.getJSON()
      }).then((res) => {

        commit('addTemplateToCollection', { templateData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/templates/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addTemplateToCollection', { templateData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateCode (store, payload) {
      return this.dispatch('put', {
        path: 'v1/templates/' + payload.id + '/code',
        data: payload
      })
    },
    updateJson (store, payload) {
      return this.dispatch('put', {
        path: 'v1/templates/' + payload.id + '/json',
        data: payload
      })
    },
    updateIcon (store, payload) {
      return this.dispatch('put', {
        path: 'v1/templates/' + payload.id + '/icon',
        data: payload
      })
    },
    updateText (store, payload) {
      return this.dispatch('put', {
        path: 'v1/templates/' + payload.id + '/text',
        data: payload
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/templates/' + id
      }).then((res) => {

        commit('removeTemplateFromCollection', id)

        return res
      })
    }
  },
  mutations: {
    addTemplateToCollection(state, { templateData, opts }) {
      addToCollection(this, state.templates, templateData, Template, opts)
    },
    addThemeToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeTemplateFromCollection(state, templateId) {
      const index = state.templates.findIndex(el => el.id === templateId)

      if (index === -1) {
        console.warn(`Could not find/delete template ${templateId}`)
        return
      }

      state.templates.splice(index, 1)
    },
    clearCollection(state) {
      state.templates = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, template) {
      state.current = template
    },
    updateCurrentCode (state, code) {
      state.currentCode = code
    },
    updateCurrentJson (state, json) {
      state.currentJson = json
    },
    updateCurrentIcon (state, icon) {
      state.currentIcon = icon
    },
    updateCurrentText (state, text) {
      state.currentText = text
    },
    resetCurrent (state) {
      state.current = new Template()
    },
    resetCurrentCode (state) {
      state.currentCode = {...initialCodeState}
    },
    resetCurrentText (state) {
      state.currentText = {...initialTextState}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/template/store.js